<template>
  <div class="results-history">
    <div class="results-history__subheader width-responsiveness">
      <h2>Laudo Histórico</h2>
      <p>
        <b style="color: #7f1a54">IMPORTANTE:</b> Tela exclusiva para acesso aos laudos liberados a mais de 5 anos.
        Serão exibidos aqui somente os Laudos histórico solicitados através de nossos canais de atendimento, sendo que o
        prazo para que seu laudo esteja disponível nessa tela é de até 1 dia útil, e podem ser solicitados no máximo 10
        laudos por chamado.
      </p>
    </div>
    <ResultsHistoryFilter />
    <ResultsHistoryList
      v-if="resultsHistoryList"
      :results-history-list-data="resultsHistoryList"
    />
    <div
      v-if="resultsHistoryDownloadLoading"
      class="overlay-loading"
    >
      <Spinner />
    </div>
  </div>
</template>

<script>
import ResultsHistoryFilter from '@/components/ResultsHistory/ResultsHistoryFilter'
import ResultsHistoryList from '@/components/ResultsHistory/ResultsHistoryList'
import Spinner from '@/components/common/Spinner'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResultsHistoryMainView',
  components: {
    ResultsHistoryFilter,
    ResultsHistoryList,
    Spinner
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['resultsHistoryList', 'resultsHistoryDownloadLoading'])
  },
  methods: {
    ...mapActions(['getServiceResultsHistory']),
    combinePDFs(pdfArray) {
      return pdfArray.map(pdfBytes => new Uint8Array(pdfBytes))
    }
  },
  mounted() {
    this.getServiceResultsHistory()
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';
@import '../../../static/stylesheets/components/orders/empty-cart';

.results-history {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  font-family: 'Exo 2', sans-serif !important;

  &__subheader {
    display: flex;
    justify-content: space-between;
    align-content: center;
    z-index: 1;
    flex-direction: column;

    h2 {
      font-size: 22px;
      font-weight: 600;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;
    }

    p {
      font-style: italic;
      font-size: 11px;
      line-height: 16px;
      margin-top: 4px;
      margin-bottom: -10px;
    }
  }

  .overlay-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000000ad;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .loader {
      border-top: 1.1em solid rgba(255, 255, 255, 0.2);
      border-right: 1.1em solid rgba(255, 255, 255, 0.2);
      border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
      border-left: 1.1em solid #ffffff;
    }
  }
}
</style>
